<template>
<div class="chapter">
<div class="inner_page">
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_5">“There are spirits that are created for vengeance,</p>
<p class="block_5">and in their fury they lay on grievous torments.”</p>
<p class="block_5">—Ecclesiastes 39:33</p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_7"> </p>
<p class="block_6" id="calibre_pb_3"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_003.vue?9178795c